// extracted by mini-css-extract-plugin
export default {"info":"ChallengeInfo_info__jPp-F","item":"ChallengeInfo_item__LCVTN","text":"ChallengeInfo_text__Ev6pc","divider":"ChallengeInfo_divider__ZA0SV"};